export default {"src":"/_next/static/media/goals.12232b6b.svg","height":662,"width":794};